import React, { Fragment } from "react";
import { CommonGrid2 } from "../../../../../modules/common-components/StyledComponents";
import { HandleSkeletion } from "../../../../../utils/constants";
import CommonButton from "../../../../../component/Button";
import { Typography } from "@mui/material";
import ChatGptIco from "../../../../../assets/icons/ChatGptIco";
import TechFetchIco from "../../../../../assets/icons/TechFetchIco";
import TickIcon from "../../../../../assets/icons/TickIcon";
import GeminiIcon from "../../../../../assets/images/GeminiIco.svg";
import MonsterLogo from "../../../../../assets/images/MonsterLogo.png";
import CalendlyLogo from "../../../../../assets/icons/CalendlyLogoIco";



export default function Card({
  dataConnector,
  loading,
  onConnect,
  onDisconnect,
}) {
  return (
    <CommonGrid2 container spacing={2} size={12}>
      {dataConnector.map((item, index) => (
        <CommonGrid2
          key={item.id || index}
          size={12}
          display={"flex"}
          gap={"10px"}
          alignItems={"center"}
          border={"1px solid #EAECF0"}
          borderRadius={"10px"}
          padding={"1rem"}
        >
          {loading ? (
            <HandleSkeletion height={40} transform="scale(1)" width={"100%"} />
          ) : (
            <Fragment>
              <CommonGrid2
                size={12}
                display={"flex"}
                gap={"1rem"}
                alignItems={"center"}
                justifyContent={"space-between"}
                flexWrap={"wrap"}
              >
                <CommonGrid2
                  display={"flex"}
                  gap={"1rem"}
                  alignItems={"center"}
                >
                  {item.name === "OpenAI" ? (
                    <ChatGptIco />
                  ) : item.name === "Tech Fetch" ? (
                    <TechFetchIco />
                  ) : item.name === "Gemini" ? (
                    <img src={GeminiIcon} width={"35px"} />
                  ) : item.name === "Monster" ? (
                    <img src={MonsterLogo} width={"35px"} />
                  ) : (
                    <CalendlyLogo />
                  )}
                  <CommonGrid2 display={"flex"} flexDirection={"column"}>
                    <Typography variant="body3"sx={{ textTransform: "capitalize" }}>{item.name}
                        </Typography>


                    <Typography
                      variant="body3"
                      color="#667085"
                      fontWeight={500}
                    >
                      {item.description}
                    </Typography>
                  </CommonGrid2>
                </CommonGrid2>
              </CommonGrid2>

              {!item.connected ? (
                <CommonButton
                  value={item.is_pending ? "Pending" : "Connect"}
                  padding={"8px 1.5rem"}
                  disabled={item.is_pending}
                  onClick={() => onConnect && onConnect(item)}
                />
              ) : (
                <CommonGrid2
                  display={"flex"}
                  gap={"1rem"}
                  width={"-webkit-fill-available"}
                  justifyContent={"end"}
                >
                  <CommonGrid2
                    display={"flex"}
                    gap={"5px"}
                    width={"fit-content"}
                    alignItems={"center"}
                  >
                    <TickIcon color={"#17B26A"} />
                    <Typography variant="h6" color="#17B26A">
                      Connected
                    </Typography>
                  </CommonGrid2>
                  <CommonButton
                    width={"fit-content"}
                    value={"Disconnect"}
                    background={"#D80027"}
                    color="#fff"
                    padding={"8px 1.5rem"}
                    onClick={() => onDisconnect && onDisconnect(item)}
                  />
                </CommonGrid2>
              )}
              {/* {item.connected ? (
                <CommonGrid2
                  display={"flex"}
                  gap={"1rem"}
                  width={"-webkit-fill-available"}
                  justifyContent={"end"}
                >
                  <CommonGrid2
                    display={"flex"}
                    gap={"5px"}
                    width={"fit-content"}
                    alignItems={"center"}
                  >
                    <TickIcon color={"#17B26A"} />
                    <Typography variant="h6" color="#17B26A">
                      Connected
                    </Typography>
                  </CommonGrid2>
                  <CommonButton
                    width={"fit-content"}
                    value={"Disconnect"}
                    background={"#D80027"}
                    color="#fff"
                    padding={"8px 1.5rem"}
                    onClick={() => onDisconnect && onDisconnect(item)}
                  />
                </CommonGrid2>
              ) : (
                <CommonButton
                  value={"Connect"}
                  padding={"8px 1.5rem"}
                  onClick={() => onConnect && onConnect(item)}
                />
              )} */}
            </Fragment>
          )}
        </CommonGrid2>
      ))}
    </CommonGrid2>
  );
}
